import {
  GET_DEEP_DIVE_REQUESTED,
  GET_DEEP_DIVE_SUCCEEDED,
  GET_DEEP_DIVE_FAILED,
} from "deepDiveEditor/actions/form";

export const deepDiveUIInitialState = {
  isLoading: false,
};

export default function(state = deepDiveUIInitialState, action) {
  switch (action.type) {
    case GET_DEEP_DIVE_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case GET_DEEP_DIVE_SUCCEEDED:
    case GET_DEEP_DIVE_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
